module services {
    export module tariff {
        export class customsTermsOfPaymentService implements interfaces.tariff.ICustomsTermsOfPaymentService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            getForDropdown(countryId: number): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {
                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "CustomsTermsOfPayment/GetForDropdown", {
                    countryId: countryId
                });
            }
        }
    }
    angular.module("app").service("customsTermsOfPaymentService", services.tariff.customsTermsOfPaymentService);
}